import { render, staticRenderFns } from "./PointVoucher.vue?vue&type=template&id=28a080a8&scoped=true"
import script from "./PointVoucher.vue?vue&type=script&lang=js"
export * from "./PointVoucher.vue?vue&type=script&lang=js"
import style0 from "./PointVoucher.vue?vue&type=style&index=0&id=28a080a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a080a8",
  null
  
)

export default component.exports